<div class="card-view-header-link">
  <a class="card-view-header-link__icon">
    <app-icon-attachment [type]="type"></app-icon-attachment>
  </a>
  <a class="link-hover" [href]="links[0]" target="_blank" (click)="$event.stopPropagation()">
    <fa-icon [icon]="externalLinkIcon"></fa-icon>
    <span>{{ links[0] }}</span>
  </a>
</div>
